export const SET_USER_LOGOUT = 'SET_USER_LOGOUT';
